<label [for]="name">{{ label }}</label>
<div class="input">
	<ng-container *ngIf="type === 'number'; else input">
		<input
			[id]="name"
			type="number"
			[formControl]="control"
			[ngClass]="{ invalid: showErrors(), 'has-icon': icon }"
			autocomplete="off"
			min="0"
			[placeholder]="placeholder"
		/>
	</ng-container>
	<ng-template #input>
		<input
			#input
			[id]="name"
			[type]="type"
			[formControl]="control"
			[placeholder]="placeholder"
			[ngClass]="{ invalid: showErrors(), 'has-icon': icon }"
			[autocomplete]="autocomplete"
		/>
	</ng-template>
	<mat-icon *ngIf="icon">{{ icon }}</mat-icon>
</div>
<div *ngIf="showErrors()" class="alert">
	<p *ngIf="control.errors?.required">Please enter a value</p>
	<p *ngIf="control.errors?.email">Please enter a valid email address</p>
	<p *ngIf="control.errors?.emailExists">Email address is already in use</p>
	<p *ngIf="control.errors?.userExists">Username already exists</p>
	<p *ngIf="control.errors?.mustMatch">Must match password</p>
	<p *ngIf="control.errors?.minlength">
		Your password must be at least {{ control.errors.minlength.requiredLength }} characters long
	</p>
</div>
